import React, { FC, useCallback, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Button from '../Button';
import { ITabElement } from '../Tabs/types';

interface IProps {
  tabName: string;
  elements: ITabElement[];
}

const TabsButton: FC<IProps> = ({ elements, tabName }) => {
  const [params, setParams] = useSearchParams();
  const [activeIdx, setActiveIdx] = useState<number>(
    elements.findIndex((el) => el.mode === (params.get('game_mode') ?? 'classic game')),
  );

  const onChangeGameMode = useCallback(
    (title: string) => {
      const idx = elements.findIndex((el) => el.title === title);
      params.set(tabName, elements[idx].queryParam);
      setActiveIdx(idx);
      setParams(params);
    },
    [params, setParams],
  );

  return (
    <>
      <Button
        variant="chooser"
        leftTitle="classic"
        centerTitle="quick"
        rightTitle="team"
        onChange={onChangeGameMode as any}
        defaultValue={(params.get('game_mode') ?? 'classic game').replace(' game', '')}
        isSettings
      />
      {elements[activeIdx].component}
    </>
  );
};

export default TabsButton;
